import angular from 'angular';
import component from './dashboard.component';
import {DashboardConfig} from './dashboard.config';
import uiRouter from 'angular-ui-router';
export default angular.module('dashboard', [uiRouter])
  .component('dashboard', component)
  .config(DashboardConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/dashboard/index.js
 **/